import { Component, OnInit } from '@angular/core';
import { Cart } from '../cart.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-itinerary-customer-requests-info',
  templateUrl: './itinerary-customer-requests-info.component.html',
  styleUrls: ['./itinerary-customer-requests-info.component.css']
})
export class ItineraryCustomerRequestsInfoComponent implements OnInit {

  cart: Cart;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.cart = this.route.parent.snapshot.data.cart;
  }

}
